import { apiHolder as api } from 'api';
import cloneDeep from 'lodash/cloneDeep';
import { actions as attachmentActions } from '../reducer/attachmentReducer';
const fileApi = api.api.getFileApi();
const systemApi = api.api.getSystemApi();
const inElectron = systemApi.isElectron();
const forwardAttachment = (_stateAttachments, attachment, entryId, cid) => {
    let newAttachments;
    let exist = false;
    const stateAttachments = cloneDeep(_stateAttachments);
    newAttachments = stateAttachments.map(item => {
        if (item.downloadId === attachment.downloadId && item.mailId === cid) {
            exist = true;
        }
        return item;
    });
    if (!exist) {
        newAttachments = [...stateAttachments, attachment];
    }
    return { newAttachments, exist };
};
export const attachmentDownloadAction = (attachment, option) => (dispatch, getState) => {
    const { attachments: stateAttachments } = getState().attachmentReducer;
    const { downloadId, id, expired } = attachment;
    if (option === null || option === void 0 ? void 0 : option.forward) {
        const { newAttachments, exist } = forwardAttachment(stateAttachments, attachment, option.entryId, option.cid);
        dispatch(attachmentActions.doSetAttachments(newAttachments));
        if (exist)
            return;
    }
    else {
        dispatch(attachmentActions.doAddAttachment([attachment]));
    }
    if (!inElectron || (option === null || option === void 0 ? void 0 : option.forward)) {
        dispatch(attachmentActions.doChangeAttachment({
            downloadId,
            id,
            status: 'success',
            expired,
        }));
        return;
    }
    dispatch(attachmentActions.doChangeAttachment({
        downloadId,
        status: 'before',
        expired,
    }));
};
export const restartDownload = (downloadId, obj) => (dispatch, getState) => {
    const { attachments: stateAttachments } = getState().attachmentReducer;
    const attachment = stateAttachments.find(item => item.downloadId === downloadId) || {};
    let fileUrl;
    let fid;
    if (obj === null || obj === void 0 ? void 0 : obj.isFromChat) {
        fileUrl = obj === null || obj === void 0 ? void 0 : obj.fileUrl;
        fid = downloadId;
    }
    else {
        fileUrl = attachment.fileUrl;
        fid = attachment.fid;
    }
    return downloadAttachment(dispatch, { downloadId, fileUrl, fid });
};
const downloadAttachment = (dispatch, { downloadId, fileUrl, fid }) => {
    dispatch(attachmentActions.doChangeAttachmentAttr({
        downloadId,
        key: 'status',
        val: 'downloading',
    }));
    return fileApi
        .download({ fileUrl, fid }, {
        flowScene: 'mail_read',
        progressIndicator: n => {
            dispatch(attachmentActions.doChangeAttachmentAttr({
                downloadId,
                key: 'process',
                val: n * 100,
            }));
        },
        operatorSet: handler => {
            dispatch(attachmentActions.doChangeAttachmentAttr({
                downloadId,
                key: 'abortDownload',
                val: handler,
            }));
        },
    })
        .then(res => {
        if (res && res.succ) {
            dispatch(attachmentActions.doChangeAttachment({
                downloadId,
                status: 'success',
            }));
        }
        else {
            dispatch(attachmentActions.doChangeAttachment({
                downloadId,
                status: 'fail',
            }));
        }
    })
        .catch(() => {
        dispatch(attachmentActions.doChangeAttachment({
            downloadId,
            status: 'fail',
        }));
    });
};
